import React from 'react';
import { createRoot } from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import './index.css';
import { MantineProvider } from '@mantine/core';
import { theme } from './theme';
import { AuthGate } from './components/AuthGate';
import { App } from './App';

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

createRoot(el).render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <AuthGate>
        <App />
      </AuthGate>
    </MantineProvider>
  </React.StrictMode>,
);
